export const AKTIVITET_STORFEHOLD = 'AKTIVITET$STORFEHOLD'
export const AKTIVITET_SVINEHOLD = 'AKTIVITET$SVINEHOLD'
export const AKTIVITET_GEITEHOLD = 'AKTIVITET$GEITEHOLD'
export const AKTIVITET_SAUEHOLD = 'AKTIVITET$SAUEHOLD'
export const AKTIVITET_SMAAFEHOLD = 'AKTIVITET$SMAAFEHOLD'
export const AKTIVITET_ALPAKKAHOLD = 'AKTIVITET$ALPAKKAHOLD'
export const AKTIVITET_KAMELHOLD = 'AKTIVITET$KAMELHOLD'
export const AKTIVITET_LAMAHOLD = 'AKTIVITET$LAMAHOLD'
export const AKTIVITET_TAMREINDRIFT = 'AKTIVITET$TAMREINDRIFT'
